export default __webpack_public_path__ + "static/3p9-wsi-296ecafe631ae87a20e23fc192177295.png";